import { ConfirmationDialog } from '@/components/common/ConfirmationDialog'

interface ProductsTableDialogsProps {
  // Copy dialog
  copyDialogOpen: boolean
  onCopyDialogChange: (open: boolean) => void
  onConfirmCopy: () => void
  copyIsLoading?: boolean

  // Delete dialog
  deleteDialogOpen: boolean
  onDeleteDialogChange: (open: boolean) => void
  onConfirmDelete: () => void
  deleteIsLoading?: boolean
}

export function ProductsTableDialogs({
  copyDialogOpen,
  onCopyDialogChange,
  onConfirmCopy,
  copyIsLoading,
  deleteDialogOpen,
  onDeleteDialogChange,
  onConfirmDelete,
  deleteIsLoading,
}: ProductsTableDialogsProps) {
  return (
    <>
      {/* Copy Confirmation Dialog */}
      <ConfirmationDialog
        open={copyDialogOpen}
        onOpenChange={onCopyDialogChange}
        title="Copy line"
        description="Are you sure you want to copy this line? A duplicate will be created below the current line."
        confirmText="Copy"
        cancelText="Cancel"
        onConfirm={onConfirmCopy}
        isLoading={copyIsLoading}
      />

      {/* Delete Confirmation Dialog */}
      <ConfirmationDialog
        open={deleteDialogOpen}
        onOpenChange={onDeleteDialogChange}
        title="Delete line"
        description="Are you sure you want to delete this line? This action cannot be undone."
        confirmText="Delete"
        cancelText="Cancel"
        onConfirm={onConfirmDelete}
        variant="destructive"
        isLoading={deleteIsLoading}
      />
    </>
  )
}
